import { environment } from 'src/environments/environment';

/**
 * Local developer access to admin dev tools without a PlateX login (e.g. /dev/valuation-lab).
 *
 * The public is kept out twice over:
 *  - this is true ONLY when the page itself is served from localhost / 127.0.0.1 by a non-production
 *    build with environment.localDevAccess on — a deployed site (dev, dev2, prod) never matches, even
 *    though `deploy-dev` builds with environment.ts;
 *  - the data comes from the assistant server, which still requires an admin token unless it is a
 *    local instance started with ASSISTANT_AUTH=off.
 */
export const localDevAccess: boolean =
  !environment.production &&
  !!(environment as any).localDevAccess &&
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);
